export default [
  {
    path: 'stores',
    name: 'Stores',
    meta: {
      permissionPath: 'subscriptions.stores',
    },
    component: () =>
      import(/* webpackChunkName: "stores" */ '@/views/loyaltyPanel/subscriptions/tabs/Stores.vue'),
  },

  {
    path: 'registration-plans',
    name: 'RegistrationPlans',
    meta: {
      permissionPath: 'subscriptions.plans.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "registrationPlans" */ '@/views/loyaltyPanel/subscriptions/tabs/RegistrationPlans.vue'
      ),
  },

  {
    path: 'payment-methods',
    name: 'LoyaltyPaymentMethods',
    meta: {
      permissionPath: 'subscriptions.store_payment_methods.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "paymentMethods" */ '@/views/loyaltyPanel/subscriptions/tabs/PaymentMethods.vue'
      ),
  },
];
